import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={errorContainerStyle}>
          <h2>Something went wrong</h2>
          <p>{this.state.error?.message || "An unexpected error occurred"}</p>
          <button 
            onClick={() => window.location.reload()}
            style={errorButtonStyle}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const errorContainerStyle = {
  padding: "20px",
  margin: "20px",
  border: "2px solid #d9534f",
  backgroundColor: "#f8d7da",
  borderRadius: "4px",
  color: "#721c24",
  textAlign: "center",
};

const errorButtonStyle = {
  marginTop: "15px",
  padding: "10px 20px",
  backgroundColor: "#d9534f",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px",
};

export default ErrorBoundary;
